import { cn } from 'ui/src/lib/utils'
import React from 'react'

type LoadingProps = {
  additionalClasses?: object
}

const Loading: React.FC<LoadingProps> = ({ additionalClasses }) => {
  return (
    <div>
      <div
        className={cn('flex', 'flex-col', 'items-center', 'justify-center', {
          ...additionalClasses,
        })}
      >
        <img src="/3-dots-fade.svg" alt="spinner" />
      </div>
    </div>
  )
}

export default Loading
